<template>
	<div class="active-advertisers">
		<v-layout row wrap fill-height>
			<v-flex xs12 class="menu-column hidden-xs-and-down">
				<Header />
			</v-flex>

			<v-flex xs12 class="div-container-activeadvertisers-card">
				<v-layout row wrap v-if="!loading" class="div-actives-advertisers">

					<v-flex xs12>
						<v-layout row wrap class="px-3 mb-3">
							<v-flex xs12 sm8 md9 class="pr-2">
								<v-select label="Categorias" item-text="name" item-value="value"
									:items="categories_options" v-model="category" />
							</v-flex>
							<v-flex xs12 sm4 md3 class="pl-2">
								<v-select label="Ordenar por Comissão" :items="sortOptions" v-model="sortOrder"
									item-text="label" item-value="value"></v-select>
							</v-flex>
						</v-layout>
					</v-flex>

					<v-flex xs12 v-if="qtdShops > 0">
						<v-layout row wrap>
							<v-flex xs12 sm12 md12 v-for="item in sortedAdvertisers" :key="item._id">
								<div class="div-container">
									<div class="div-each-advertiser-bond">
										<div class="div-layout-information-advertiser-bond">
											<div :id="`logo_${item.name_tag}`" class="div-logo-advertiser">
												<img :src="item.img_logo" alt="Logo Anunciante">
											</div>
											<div class="div-information-each-advertiser">
												<p class="paragrafo-name">{{ item.register.reg_name }}</p>
												<p class="paragrago-campaign">{{ item.reg_name }}</p>

												<p class="paragrafo-commission-variable">Comissão variável:
													<span>{{ formatPricePercentage(item.commission_variable) }}%</span>
												</p>
												<p class="paragrafo-payment">Comissionamento:
													<span>{{ formatPaymentCommission(item.commission_period) }}</span>
												</p>
												<p class="paragrafo-window">Janela de atribuição:
													<span>{{ AgeCookie(item.cookie_age_hours) }}</span>
												</p>
											</div>
										</div>
										<div class="div-buttons-advertisers">
											<a :href="createdLinkForDivulgation(item)" target="_blank">
												Ir para o site
											</a>
											<button @click="GenerateLinkForDivulgation(item)">
												Gerar link
											</button>
										</div>
									</div>
								</div>
							</v-flex>
						</v-layout>
					</v-flex>

					<v-flex xs12 v-else>
						<v-layout row wrap>
							<v-flex xs12 sm12 md12 class="container-without-shops">
								<div v-if="category != ''" class="container-without-advertiser">
									<p>Você não está vinculado há nenhuma loja de <strong>{{ category }}</strong></p>
								</div>
								<div v-else class="container-without-advertiser">
									<p>Você não está vinculado há nenhuma loja da plataforma</p>
								</div>
							</v-flex>
						</v-layout>
					</v-flex>

				</v-layout>

				<v-layout row wrap v-else>
					<v-flex xs12 sm12 md12 class="div-loading-circle">
						<v-progress-circular indeterminate></v-progress-circular>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
import Header from '../components/Header.vue'
import categories from '@/utils/advertiserCategories'
import { affiliate_api } from '@/api'

export default {
	name: 'ActiveAdvertisers',
	mixins: [affiliate_api],
	components: {
		Header,
	},
	data() {
		return {
			loading: false,
			showCopied: false,
			qtdShops: null,
			categories_options: categories,
			category: '',
			linkShortedForDivulgation: '',
			adv: [],
			// Controle de ordenação inicializado como null (Padrão)
			sortOrder: null,
			sortOptions: [
				{ label: 'Padrão', value: null }, // Opção para resetar a ordem
				{ label: 'Maior Comissão', value: 'desc' },
				{ label: 'Menor Comissão', value: 'asc' }
			]
		}
	},
	computed: {
		// Computed property para ordenar a lista sem mutar o array original
		sortedAdvertisers() {
			if (!this.adv || !this.adv.data) return []

			// SE NÃO TIVER ORDENAÇÃO SELECIONADA (PADRÃO), RETORNA A LISTA ORIGINAL DA API
			if (!this.sortOrder) {
				return this.adv.data
			}

			// Se tiver ordenação, cria uma cópia e ordena
			let items = [...this.adv.data]

			items.sort((a, b) => {
				let valA = a.commission_variable || 0
				let valB = b.commission_variable || 0

				if (this.sortOrder === 'asc') {
					return valA - valB
				} else {
					return valB - valA
				}
			})

			return items
		}
	},
	methods: {
		formatPrice: function (value) {
			if (!value) return '0,00'
			return value.toFixed(2).replace('.', ',')
		},
		formatPricePercentage: function (value) {
			var percentage = (100 * value)
			return percentage.toFixed(2).replace('.', ',')
		},
		formatPaymentCommission: function (value) {
			if (!value) return 'mensal'
			var payment = (value === 'monthly') ? 'mensal' : 'semanal'
			return payment
		},
		AgeCookie: function (value) {
			if (value) {
				if (value > 24) {
					let hours = value % 24
					let days = (value - hours) / 24
					let ret = `${days} dia`
					if (days > 1) { ret += 's' }
					if (hours > 0) {
						ret += ` e ${hours} hora`
						if (hours > 1) { ret += 's' }
					}
					return ret
				}
			} else {
				return '-'
			}
		},
		createdLinkForDivulgation: function (value) {
			if (!value) return ''
			return `${value.domain}?utm_source=magafilio&utm_term=${value._id}&utm_campaign=${value.campaign}&utm_medium=cpa`
		},
		handleSubmitCopied: function () {
			this.showCopied = true
			var interval = setInterval(() => {
				this.showCopied = false
				clearInterval(interval)
			}, 2000)
		},
		GenerateLinkForDivulgation: async function (value) {
			if (!value) return ''
			var link = `${value.domain}?utm_source=magafilio&utm_term=${value._id}&utm_campaign=${value.campaign}&utm_medium=cpa`
			var linkShorted = await this.post_shorted_link(link)

			if (linkShorted.status === 200) {
				this.linkShortedForDivulgation = linkShorted.data
				this.$copyText(this.linkShortedForDivulgation)
				this.$notify({
					type: 'success',
					title: 'Link gerado e copiado com sucesso!',
				})
			} else {
				this.$notify({
					type: 'error',
					title: 'Erro ao gerar seu link!',
				})
			}
		}
	},
	watch: {
		category: async function () {
			const magauser = localStorage.getItem('magauser')
			this.loading = true
			this.adv = await this.get_mgu_adv_list(magauser, this.category)
			this.loading = false
			this.qtdShops = this.adv.data.length
		}
	},
	created: async function () {
		const magauser = localStorage.getItem('magauser')
		this.adv = await this.get_mgu_adv_list(magauser)
		this.qtdShops = this.adv.data.length
	}
}
</script>

<style>
div.active-advertisers {
	margin: 55px 10px 95px 10px;
}

/* CONTAINER PRINCIPAL ALINHADO */
.div-container-activeadvertisers-card {
	padding-left: 20px !important;
	width: 100% !important;
	max-width: 100% !important;
}

.div-actives-advertisers {
	margin-top: 20px;
	padding: 12px;
}

.div-container-activeadvertisers-card .div-loading-circle {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 80vh;
}

.div-container-activeadvertisers-card .div-loading-circle circle.v-progress-circular__overlay {
	color: #40DA99 !important;
}

.div-actives-advertisers .div-container {
	display: flex;
	align-items: flex-start;
	flex-direction: column;
	margin: 15px 0px;
	padding: 12px;
	width: 100%;
}

.div-container-activeadvertisers-card .div-actives-advertisers .div-each-advertiser-bond {
	display: flex;
	align-items: center;
	justify-content: space-evenly;
	padding: 12px;
	border-radius: 16px;
	width: 100%;
}

.div-each-advertiser-bond .div-layout-information-advertiser-bond {
	display: flex;
	align-items: center;
	justify-content: center;
}

.div-each-advertiser-bond .div-logo-advertiser {
	box-sizing: border-box;
	border-radius: 50%;
	width: 100px;
	height: 100px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: 20px;
}

.div-each-advertiser-bond .div-logo-advertiser img {
	width: 70px;
	height: 30px;
}

.div-actives-advertisers .div-information-each-advertiser p {
	margin: 0px;
}

.div-actives-advertisers .div-information-each-advertiser p.paragrafo-name {
	font-weight: 600;
	font-size: 18px;
	line-height: 23px;
	margin-left: 3px;
}

.div-actives-advertisers .div-information-each-advertiser p.paragrago-campaign {
	font-size: 9.5px;
	margin: 0px 0px 12px 3px;
	opacity: 0.6;
}

.div-actives-advertisers .div-information-each-advertiser p.paragrafo-commission-fixe,
.div-actives-advertisers .div-information-each-advertiser p.paragrafo-commission-variable,
.div-actives-advertisers .div-information-each-advertiser p.paragrafo-payment,
.div-actives-advertisers .div-information-each-advertiser p.paragrafo-window {
	font-size: 11px;
	line-height: 14px;
	margin: 3px 0px 4px 3px;
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.div-actives-advertisers .div-information-each-advertiser p.paragrafo-commission-fixe span,
.div-actives-advertisers .div-information-each-advertiser p.paragrafo-commission-variable span,
.div-actives-advertisers .div-information-each-advertiser p.paragrafo-payment span,
.div-actives-advertisers .div-information-each-advertiser p.paragrafo-window span {
	font-weight: bold;
	margin-left: 45px;
}

.div-actives-advertisers .div-buttons-advertisers {
	margin-left: auto;
	padding-right: 20px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}

.div-actives-advertisers .div-buttons-advertisers a {
	text-decoration: none;
	box-sizing: border-box;
	border-radius: 24px;
	padding: 2px 18px;
	transition: opacity 0.4s;
	margin-bottom: 15px;
}

.div-actives-advertisers .div-buttons-advertisers a:hover {
	opacity: 0.6;
}

.div-actives-advertisers .div-buttons-advertisers button {
	box-sizing: border-box;
	border-radius: 24px;
	padding: 2px 28px;
	transition: opacity 0.4s;
}

.div-actives-advertisers .div-buttons-advertisers button:hover {
	opacity: 0.6;
}

.container-without-shops {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 20vh;
}

.container-without-shops div.container-without-advertiser {
	border: 1px solid #40DA99;
	padding: 12px;
	border-radius: 24px;
}

.container-without-shops div.container-without-advertiser p {
	margin: 0px;
	opacity: 0.7;
}

.v-menu__content.menuable__content__active {
	top: 138px !important;
	border-radius: 0px 0px 13px 13px !important;
}

.v-list__tile {
	width: 100% !important;
}

.v-label.v-label--active.theme--light {
	top: 0px !important;
	left: 3px !important;
}

.v-select__slot {
	padding: 0 12px;
}

@media (max-width: 1000px) {
	.div-container-activeadvertisers-card {
		margin: auto !important;
		padding-left: 0 !important;
	}
}

@media (max-width: 960px) {
	.div-each-advertiser-bond {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.div-each-advertiser-bond .div-buttons-advertisers {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		margin-top: 15px;
		margin-left: 0;
		padding-right: 0;
	}

	.div-each-advertiser-bond .div-buttons-advertisers a {
		margin: 0px 15px 0px 0px;
	}
}

@media (max-width: 750px) {
	.div-actives-advertisers .div-buttons-advertisers {
		font-size: 10px;
	}
}

@media (max-width: 425px) {
	.div-layout-information-advertiser-bond {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.div-layout-information-advertiser-bond .div-logo-advertiser {
		margin: 0px 0px 10px 0px;
	}

	.div-layout-information-advertiser-bond .div-information-each-advertiser {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
}

.theme--dark .div-container-activeadvertisers-card .div-actives-advertisers .div-each-advertiser-bond {
	background: #2D2F32;
	box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.25);
}

.theme--dark #logo_wevans,
.theme--dark #logo_amevestir,
.theme--dark #logo_mmoda,
.theme--dark #logo_pumpupdecor,
.theme--dark #logo_shop77,
.theme--dark #logo_holyfit,
.theme--dark #logo_phtmoda,
.theme--dark #logo_universobasico,
.theme--dark #logo_doremibebe,
.theme--dark #logo_feiraodacamiseta,
.theme--dark #logo_karterr,
.theme--dark #logo_mixdamoda {
	background: #1A1A1A;
}

.theme--dark .div-each-advertiser-bond .div-logo-advertiser {
	background: #FBFBFB;
	border: 5px solid #2D2F32;
	box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.25), -4px -4px 8px rgba(74, 74, 74, 0.25);
}

.theme--dark .div-actives-advertisers .div-buttons-advertisers a {
	background: #2D2F32;
	border: 1px solid #2D2F32;
	box-shadow: -2px -2px 4px rgba(74, 74, 74, 0.25), 2px 2px 4px rgba(0, 0, 0, 0.25);
	color: #40DA99 !important;
}

.theme--dark .div-actives-advertisers .div-buttons-advertisers button {
	background: #40DA99;
	border: 1px solid #2D2F32;
	box-shadow: -2px -2px 4px rgba(74, 74, 74, 0.25), 2px 2px 4px rgba(0, 0, 0, 0.25);
	color: #2D2F32 !important;
}

.theme--dark .v-list {
	background-color: #2D2F32 !important;
	padding: 12px;
}

.theme--light .div-container-activeadvertisers-card .div-actives-advertisers .div-each-advertiser-bond {
	background: #FFFFFF;
	box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);
}

.theme--light #logo_wevans,
.theme--light #logo_amevestir,
.theme--light #logo_mmoda,
.theme--light #logo_pumpupdecor,
.theme--light #logo_shop77,
.theme--light #logo_holyfit,
.theme--light #logo_phtmoda,
.theme--light #logo_universobascico,
.theme--light #logo_doremibebe,
.theme--light #logo_feiraodacamiseta,
.theme--light #logo_karterr,
.theme--light #logo_mixdamoda {
	background: #FBFBFB;
}

.theme--light .div-each-advertiser-bond .div-logo-advertiser {
	background: #FBFBFB;
	border: 5px solid #FFFFFF;
	box-shadow: -2px -2px 4px rgba(255, 255, 255, 1), 2px 2px 4px rgba(0, 0, 0, 0.1);
}

.theme--light .div-actives-advertisers .div-buttons-advertisers a {
	background: #F5F5F5;
	border: 1px solid #F5F5F5;
	box-shadow: -2px -2px 4px rgba(255, 255, 255, 1), 2px 2px 4px rgba(0, 0, 0, 0.1);
	color: #40DA99 !important;
}

.theme--light .div-actives-advertisers .div-buttons-advertisers button {
	background: #40DA99;
	border: 1px solid #F5F5F5;
	box-shadow: -2px -2px 4px rgba(255, 255, 255, 1), 2px 2px 4px rgba(0, 0, 0, 0.1);
	color: #2D2F32 !important;
}

.theme--light .v-list {
	background-color: #FFFFFF !important;
	padding: 12px;
}

@media (min-width: 600px) {

	.menu-column {
		flex: 0 0 215px !important;
		max-width: 215px !important;
	}

	.div-container-activeadvertisers-card {
		flex: 1 !important;
		max-width: calc(100% - 215px) !important;
		width: auto !important;
	}
}
</style>